import React from 'react';
import styles from '../../../components/RichText/RichText.module.scss';
import { extractInlineStyles } from '../utils';
const RichTextBold = ({ children, value }) => (React.createElement("strong", { className: styles.richTextStrong, style: extractInlineStyles(value) }, children));
RichTextBold.displayName = 'RichTextBold';
export default RichTextBold;
//# sourceMappingURL=Bold.js.map